t = require('app/scripts/views/internal/teacup-with-helpers')('member_inline')

module.exports = ->
  t.mustacheBlock 'avatarHash', ->
    t.img '.inline-member-av', { src: t.mustacheVar('__avatarDomain') + '/' + t.mustacheVar('avatarHash') + '/30.png', alt: t.mustacheVar('viewTitle'), title: t.mustacheVar('viewTitle') }
  t.span '.u-font-weight-bold', ->
    t.text t.mustacheVar('fullName')
